/* eslint no-param-reassign: 0 */
import { TagsService } from '../services/tags.service';

const tagsState = {
  tags: [],
  timestamp: null,
};

const mutations = {
  setTags(state, tags) {
    state.tags = tags;
    state.timestamp = Date.now();
  },
};

const getters = {
  tags: state => state.tags,
};

const actions = {
  getTags: async ({ commit, state }, override = false) => {
    const { timestamp } = state;
    if (timestamp !== null && !override) {
      const diff = Date.now() - timestamp;
      if (Math.floor(diff / 1000) < 60) {
        return;
      }
    }
    try {
      const tags = await TagsService.getTags();
      const reforgedTags = tags.map(t => ({ key: t.name, value: t.name, string: t.name }));
      commit('setTags', reforgedTags);
    } catch (e) { /* Do nothing */ }
  },
};

export default {
  namespaced: true,
  state: tagsState,
  mutations,
  getters,
  actions,
};
